import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'semantic-ui-react'
import history from '../../services/history'

export default () => {

    const preventRouting = [
        'dre',
        'fiscal contabil',
        'combustivel',
        'controladoria',
        'apuracao fechamento caixa',
        'conferencias',
        'nfce'
    ]

    // Fucking pig mode...do something else another time...maybe '-'
    function transformWords(str) {
        switch (str) {
            case 'apuracao icms': return 'Apuração ICMS'
            case 'apuracao fechamento caixa': return 'Apuração Fechamento de Caixa'
            case 'regulamento icms': return 'Regulamento ICMS'
            case 'dre': return 'DRE'
            case 'conferencias': return 'Conferências'
            case 'fiscal contabil': return 'Fiscal / Contábil'
            case 'nfce': return 'NFC-e'
            case 'diferencas': return 'Diferenças'
            case 'conferencia': return 'Conferência'
            case 'relatorios': return 'Relatórios'
            case 'listar digitacoes': return 'Listar Digitações'
            default: return str
        }
    }

    const paths = history.location.pathname.split('/').map((p, i, arr) => {

        if (i === 0) {
            return {
                key: i,
                content: (<Link to={'/'}>Início</Link>),
                active: (i === arr.length - 1),
                link: (i < arr.length - 1)
            }
        }

        if (i === arr.length - 1 || preventRouting.includes(p.replace(/-/g, ' '))) {
            return {
                key: i,
                content: transformWords(p.replace(/-/g, ' ')),
                active: (i === arr.length - 1)
            }
        }

        return {
            key: i,
            content: (<Link to={`${arr.slice(0, i + 1).join('/')}`}>{transformWords(p.replace(/-/g, ' '))}</Link>),
            active: (i === arr.length - 1),
            link: (i < arr.length - 1)
        }
    })

    return <Breadcrumb size='mini' style={{ textTransform: 'capitalize' }}>
        {paths && paths.map((p, i) => {
            if (i !== paths.length - 1) {
                return (
                    <React.Fragment key={p.key}>
                        <Breadcrumb.Section as='span' active={p.active} content={p.content} link={p.link} />
                        <Breadcrumb.Divider icon='chevron right' />
                    </React.Fragment>
                )
            }
            return <Breadcrumb.Section key={p.key} as='span' active={p.active} content={p.content} link={p.link} />
        })}
    </Breadcrumb>
}
